import { joinUrlPath } from '@/utils/common';
import { apiPrefix } from '@/config/base';
import { apiRequest } from '@/utils/request';

export function getAppInfo({ data = {} }) {
  return apiRequest({
    method: 'post',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/funnel/get-query-id'),
    data,
    restful: true,
  });
}

export function getUserList({ params = {} }) {
  return apiRequest({
    method: 'get',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/tmc-user/list'),
    params,
    restful: false,
  });
}

export function getAppUserList({ params = {} }) {
  return apiRequest({
    method: 'get',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/app/user/list'),
    params,
    restful: false,
  });
}

export function addAppUser({ data } = {}) {
  return apiRequest({
    method: 'post',
    url: joinUrlPath(apiPrefix, `/tmc-dap-metadata-api/v1/app/user`),
    data,
  });
}

export function modifyAppUser({ data } = {}) {
  return apiRequest({
    method: 'put',
    url: joinUrlPath(apiPrefix, `/tmc-dap-metadata-api/v1/app/user`),
    data,
  });
}

export function deleteAppUser(id) {
  return apiRequest({
    method: 'delete',
    url: joinUrlPath(apiPrefix, `/tmc-dap-metadata-api/v1/app/user/${id}`),
  });
}
